
export * from '../../../frontend-js-react-web/__liferay__/exports/classnames.js';

import __default__ from '../../../frontend-js-react-web/__liferay__/exports/classnames.js';
export default __default__;
